import { Injectable } from '@angular/core';
import {
  Firestore
} from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { ActivityLog } from './activity-log.models';

/**
 * ActivityLog Firestore data-access service.
 * Extends {@link FirestoreBase} to reuse generic CRUD and query helpers.
 * Use inherited methods such as `get$`, `getOneWhere$`, `create`, `upsert`, and `update`
 * from higher layers (`activityLog.service`) unless an activity log-specific query is required.
 */
@Injectable({ providedIn: 'root' })
export class ActivityLogDbService extends FirestoreBase<ActivityLog> {

  constructor(firestore: Firestore) {
    super(
      'activityLogs',
      firestore
    );
  }
}
